import React from "react";
import Head from "next/head";
import { string } from "prop-types";

const PageTitle = ({ title }) => {
	return title ? (
		<Head>
			<title>{title}</title>
			<meta property="og:title" content={title} key="title" />
		</Head>
	) : null;
};

PageTitle.propTypes = {
	title: string,
};

export default PageTitle;
